<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

  <app-page-hero
    eyebrow="Warehousing"
    title="Mark Refurbishment"
    subtitle="Refurbishment does not deduct stock and remains billable."
    backLink="/warehousing/refurbishment">
    <div actions>
      <p-button label="Mark Refurbishment" icon="pi pi-wrench" severity="warn" type="button" [loading]="isSaving" [disabled]="isSaving || evidenceUploadInProgress" (click)="createRefurbishment()"></p-button>
    </div>
  </app-page-hero>

  <form [formGroup]="refurbishmentForm" (ngSubmit)="createRefurbishment()" class="warehousing-form-grid p-fluid">
    <app-page-form-section icon="pi pi-box" title="Stock Unit" subtitle="Select the exact stock unit that is moving into refurbishment.">
      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon>
        <p-iftaLabel>
          <p-select id="stockUnitId" [options]="stockUnits" optionLabel="label" optionValue="id" formControlName="stockUnitId" [filter]="true" filterBy="label" styleClass="w-full"></p-select>
          <label for="stockUnitId">Stock Unit</label>
        </p-iftaLabel>
      </p-inputGroup>
    </app-page-form-section>

    <app-page-form-section icon="pi pi-wrench" title="Execution and Cost" subtitle="Track responsibility, cost estimates, evidence, and internal notes.">
      <div class="formgrid grid">
        <div class="field col-12 md:col-4"><p-inputGroup><p-inputGroupAddon><i class="pi pi-cog"></i></p-inputGroupAddon><p-iftaLabel><p-select id="sourceType" [options]="refurbishmentSources" optionLabel="label" optionValue="value" formControlName="sourceType" styleClass="w-full"></p-select><label for="sourceType">Internal / Outsourced</label></p-iftaLabel></p-inputGroup></div>
        <div class="field col-12 md:col-4">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select
                id="supplierClientId"
                [options]="supplierClients"
                optionLabel="companyName"
                optionValue="id"
                formControlName="supplierClientId"
                [filter]="true"
                filterBy="companyName,clientNumber"
                [showClear]="true"
                [disabled]="!supplierRequired()"
                styleClass="w-full"></p-select>
              <label for="supplierClientId">Supplier CRM Client</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-4"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftaLabel><input id="startDate" pInputText type="date" formControlName="startDate"><label for="startDate">Start Date</label></p-iftaLabel></p-inputGroup></div>
        <div class="field col-12 md:col-6"><p-inputGroup><p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon><p-iftaLabel><p-inputNumber inputId="estimatedCost" formControlName="estimatedCost" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" styleClass="w-full"></p-inputNumber><label for="estimatedCost">Estimated Cost</label></p-iftaLabel></p-inputGroup></div>
        <div class="field col-12 md:col-6"><p-inputGroup><p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon><p-iftaLabel><p-inputNumber inputId="actualCost" formControlName="actualCost" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" styleClass="w-full"></p-inputNumber><label for="actualCost">Actual Cost</label></p-iftaLabel></p-inputGroup></div>
        <div class="field col-12">
          <div class="flex flex-column gap-3">
            <p-fileUpload
              mode="basic"
              [customUpload]="true"
              chooseLabel="Upload Evidence"
              chooseIcon="pi pi-upload"
              accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
              [auto]="true"
              [disabled]="evidenceUploadInProgress"
              (uploadHandler)="uploadEvidence($event)"></p-fileUpload>
            <p-progressBar *ngIf="evidenceUploadInProgress" [value]="evidenceUploadProgress"></p-progressBar>
            <div class="grid" *ngIf="uploadedEvidenceUrls.length">
              <div class="col-12 md:col-4" *ngFor="let url of uploadedEvidenceUrls">
                <div class="border-1 surface-border border-round p-3 h-full flex flex-column gap-2">
                  <p-image *ngIf="isImageUrl(url)" [src]="url" [preview]="true" alt="Refurbishment evidence" imageClass="w-full border-round" styleClass="w-full"></p-image>
                  <a [href]="url" target="_blank" rel="noopener noreferrer" class="text-primary no-underline font-medium">{{ evidenceFileName(url) }}</a>
                  <p-button icon="pi pi-trash" label="Remove" severity="danger" [text]="true" type="button" (click)="removeEvidence(url)"></p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="field col-12">
          <label for="notes" class="block text-700 font-medium mb-2">Notes</label>
          <p-editor id="notes" formControlName="notes" [style]="{ height: '220px' }"></p-editor>
        </div>
      </div>
    </app-page-form-section>
  </form>
</app-page-shell>
